/**
 * Round 20 V5 -- an admitted service with no recorded owner.
 *
 * New account opening carried the oldest open critical finding raised
 * on an IBS, an approved tolerance its owner had countersigned, and no
 * recorded owner -- and nothing said so on its page, the portfolio or
 * the IBS register, where audit looks. One component, so the three say
 * it in one way.
 */
import { useTranslation } from "react-i18next";

export function NoOwnerFlag({
  openCritical = 0,
  testid = "no-owner-flag",
}: {
  openCritical?: number;
  testid?: string;
}) {
  const { t } = useTranslation();
  return (
    <span
      data-testid={testid}
      className="ms-2 inline-block rounded border border-rose-200 bg-rose-50 px-1.5 py-0.5 text-[10px] font-medium text-rose-800"
    >
      {openCritical > 0
        ? t("noOwner.withCritical", { count: openCritical })
        : t("noOwner.plain")}
    </span>
  );
}
